import React from "react";

export default function Footer() {
  return (
    <footer className="relative z-[999] w-full bg-[#142936] text-gray-200 px-6 sm:px-8 md:px-20 py-12 md:py-16">
      
      {/* ===== GRID ===== */}
      <div
        className="
          mx-auto
          grid
          grid-cols-1
          sm:grid-cols-[repeat(2,auto)]
          lg:grid-cols-[repeat(4,auto)]
          justify-center
          gap-y-10
          gap-x-24
          items-start
          max-w-7xl
        "
      >
        
        {/* ===== Address ===== */}
        <div className="flex flex-col gap-1 text-center sm:text-left">
          <h3 className="text-base sm:text-lg font-semibold uppercase mb-2">
            Our Address
          </h3>
          <p className="text-gray-400 text-sm sm:text-base">
            9th floor 910, Gulberg
          </p>
          <p className="text-gray-400 text-sm sm:text-base">
            Al Hafeez Heights
          </p>
          <p className="text-gray-400 text-sm sm:text-base">
            Lahore, Pakistan
          </p>
        </div>

        {/* ===== Contact ===== */}
        <div className="flex flex-col gap-1 text-center sm:text-left">
          <h3 className="text-base sm:text-lg font-semibold uppercase mb-2">
            Contact
          </h3>
          <p className="text-gray-400 text-sm sm:text-base">
            info@broadboyadventures.com
          </p>
          <p className="text-gray-400 text-sm sm:text-base">
            +1 716-579-1720
          </p>
        </div>

        {/* ===== Navigation ===== */}
        <div className="flex flex-col gap-1 text-center sm:text-left">
          <h3 className="text-base sm:text-lg font-semibold uppercase mb-2">
            Navigation
          </h3>
          <a href="/" className="hover:text-white text-gray-400 transition text-sm sm:text-base">
            Home
          </a>
          <a href="/adventures/expeditions" className="hover:text-white text-gray-400 transition text-sm sm:text-base">
            Expeditions
          </a>
          <a href="/services" className="hover:text-white text-gray-400 transition text-sm sm:text-base">
            Service
          </a>
          <a href="/terms-of-service" className="hover:text-white text-gray-400 transition text-sm sm:text-base">
            Terms of Services
          </a>
        </div>

        {/* ===== Socials ===== */}
        <div className="flex flex-col gap-1 text-center sm:text-left">
          <h3 className="text-base sm:text-lg font-semibold uppercase mb-2">
            Follow Us
          </h3>
          <a
            href="https://www.instagram.com/bb.adventures_"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white text-gray-400 transition text-sm sm:text-base"
          >
            Instagram
          </a>
          <a
            href="https://x.com/Shehrozekashif2"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white text-gray-400 transition text-sm sm:text-base"
          >
            X (Twitter)
          </a>
          <a
            href="https://www.facebook.com/broadboyadventures/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white text-gray-400 transition text-sm sm:text-base"
          >
            Facebook
          </a>
        </div>
      </div>

      {/* ===== Brand Name ===== */}
      <div className="mt-14 border-t border-gray-700 pt-8 text-center">
        <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold text-gray-300 leading-tight">
          BroadBoy Adventures
        </h1>
      </div>
    </footer>
  );
}
